import React from 'react';
import {
  ButtonAppearance,
  ButtonCustom,
  Richtext,
  Breakpoints,
  Text,
  TextAppearance,
  buttonPaddingGenerator,
} from '@vw-marketing/us-components';
import {
  StyledDescriptionContainer,
  StyledLineTitle,
  StyledLineContainer,
  StyledContent,
  StyledCarFaxWrapper,
} from './styles';
import {modalsData} from '../../store/local-storage';
import {UsedVehicle} from '../../typing/used-inventory';
import {ModalDisplayMode} from '../../typing/modal-display';
import {useTranslations} from '../../hooks/use-translations';

export interface CarFaxProps {
  vehicle: UsedVehicle;
}

const CarFax = (props: CarFaxProps): JSX.Element => {
  const {vehicle} = props;
  const translations = useTranslations().detailsSection.carFaxBox;
  const handleShowCarFaxCTAClick = () => {
    modalsData({
      vehicle,
      active: true,
      mode: ModalDisplayMode.REDIRECT_CARFAX_SITE,
      urlRedirect: `${vehicle.carfaxLink?.url}`,
    });
  };

  return vehicle.carfaxLink ? (
    <StyledCarFaxWrapper className="carfax-wrapper">
      <StyledLineContainer className="line-container">
        <StyledLineTitle className="line-title">
          <Richtext dangerouslyParseRawHTML markdown={translations.title} />
        </StyledLineTitle>
        <StyledContent className="carfax-content">
          <ButtonCustom
            appearance={ButtonAppearance.Secondary}
            onClick={handleShowCarFaxCTAClick}
            stretchContent
            padding={buttonPaddingGenerator(12, 10, 15, 15)}
          >
            <Text
              appearance={TextAppearance.copy200}
            >
              {translations.ctaText}
            </Text>
          </ButtonCustom>
          <StyledDescriptionContainer className="carfax-description-container">
            <Text className="carfax-description-text">
              {translations.description}
            </Text>
          </StyledDescriptionContainer>
        </StyledContent>
      </StyledLineContainer>
    </StyledCarFaxWrapper>
  ) : (
    <></>
  );
};

export default CarFax;
